import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";


import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import ChainCircle, { RightArrow, RefreshLogo } from '../Svg/index';

import styles from './stylesheets/RegisteredUserHeader.module.css';

export class RegisteredUserHeader extends Component {
    render() {
        return (
            <div className={styles.zuzLogo}>
                <img src={zuzLogo} alt="zuz logo" />
            </div>
        )
    }
}

export default RegisteredUserHeader
